import gwLogoUrl from "@/assets/gw-logo.svg";

interface Props {
  /**
   * `fullscreen` covers the viewport (boot/login); `overlay` covers a positioned parent; `inline` is the
   * mark at 20 px next to its label, for a status line (a drawer updating its rows under new filters).
   */
  variant?: "fullscreen" | "overlay" | "inline";
  label?: string;
}

/**
 * GorillaWorks-branded loading indicator: the logo with a gentle pulse inside a spinning
 * brand-gradient ring. Used full-screen during the login/boot handshake and as a content-area
 * overlay while a screen or filter change is loading (so partial filters/tables never show).
 */
export function BrandedLoader({ variant = "overlay", label = "Loading…" }: Props) {
  return (
    <div className={`gw-loader ${variant}`} role="status" aria-live="polite">
      <div className="gw-loader-inner">
        <span className="gw-loader-mark">
          <span className="gw-loader-ring" aria-hidden="true" />
          <img src={gwLogoUrl} alt="" className="gw-loader-logo" aria-hidden="true" />
        </span>
        {label && <span className="gw-loader-label">{label}</span>}
      </div>
    </div>
  );
}
